import React from "react"
import PropTypes from "prop-types"

export default class TryItOutButton extends React.Component {

  static propTypes = {
    onTryoutClick: PropTypes.func,
    onCancelClick: PropTypes.func,
    enabled: PropTypes.bool, // Try it out is enabled, ie: the user has access to the form
  };

  static defaultProps = {
    onTryoutClick: Function.prototype,
    onCancelClick: Function.prototype,
    enabled: false,
  };

  render() {
    const { onTryoutClick, onCancelClick, enabled } = this.props

    return enabled ? (<button className="btn btn-toggle-test pull-right" onClick={ onCancelClick }>Cancel</button>)
                  : (<button className="btn btn-toggle-test pull-right" onClick={ onTryoutClick }>Try it out </button>)
  }
}



// WEBPACK FOOTER //
// ./src/core/components/try-it-out-button.jsx